import { createElement, memo, useContext } from '@max/max';
const isWeb = true;
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import styles from './index.module.scss';
import { GOODS_STATUS } from '../../types';
import Sensor from '@max/mbc-sensor';
import { LX_CONFIG, SHOW_TYPE_ENUM } from '../../constants';
import { adaptScreenWidth } from '../../common-api/utils';
import { useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import { navigateToDetailPage } from '../../utils/navigate';
const isMRN = false;
import CornerMark from '../CornerMark';
import LinearGradient from '@hfe/max-linear-gradient';
const ShowSize = {
    [SHOW_TYPE_ENUM.SIGNAL_ROW]: 'small',
    [SHOW_TYPE_ENUM.TWO_LIST]: 'normal',
    [SHOW_TYPE_ENUM.THREE_COLUMN]: 'normal'
};
const ImageSize = {
    small: {
        width: '314rpx',
        height: '235rpx'
    },
    normal: {
        width: '342rpx',
        height: '256rpx'
    }
};
const MyComponent = (props) => {
    const { headImage, positionInfo, title, price, buyButtonText, salesCount, score, rating, bookInfo, userReview, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, headIconBorderColor, scoreInfoSwitch, bookInfoSwitch, distanceInfoSwitch, salesInfoSwitch, buyButtonTextColor, buyButtonBackgroundColor, status, priceColor, extModel, lat, lng, poiId, angleImg, privilegeTag, posTagList } = props.poiInfo;
    const { showType = SHOW_TYPE_ENUM.TWO_LIST, clickBizLine, isOpenComparePriceTag, poiIdList, poiIdUrlExtraParamsString, itemIndex, showCornerMark } = props;
    const { sellPrice, originalPrice, discountInfo } = price || {};
    const ctx = useContext(global?._EngineGlobalContext);
    const { monitorNavigateTo } = useMonitorNavigation();
    const { _LXReport, _moduleId } = ctx;
    const onCardClick = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        const shopuuid = extModel.shopUuid;
        const shopIdStr = extModel.shopIdStr;
        if (!poiId || status !== GOODS_STATUS.CAN_SALE || window?.inEditor) {
            return;
        }
        const custom = {};
        const hotelchannel = ctx?._runtimeInfo?.queryParams?.hotelchannel;
        if (hotelchannel) {
            custom.hotel_channel = hotelchannel;
        }
        if (clickBizLine) {
            custom.click_biz_line = clickBizLine;
        }
        const val_lab = {
            _moduleId: _moduleId ?? '-999',
            poi_id: poiId,
            item_index: itemIndex,
            is_privilege: privilegeTag,
            is_ddt_label: Boolean(angleImg?.needTag),
            tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
            custom
        };
        _LXReport?.mcReportWithTag?.(LX_CONFIG.CARD_MC_BID, {
            valLab: val_lab
        });
        navigateToDetailPage({
            poiId,
            shopuuid,
            hotelchannel,
            shopIdStr: shopIdStr || ''
        }, monitorNavigateTo, {
            isNeedAdd: Array.isArray(poiIdList) && poiIdList?.indexOf(poiId?.toString()) > -1,
            extraParamsString: poiIdUrlExtraParamsString,
            anchor: props.detailPageAnchor,
            externalParams: props.externalParams
        });
    };
    const onCardShow = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        _LXReport?.mvReport(LX_CONFIG.CARD_MV_BID, {
            valLab: {
                _moduleId: _moduleId ?? '-999',
                poi_id: poiId,
                item_index: itemIndex,
                is_privilege: privilegeTag,
                is_ddt_label: Boolean(angleImg?.needTag),
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999',
                    click_biz_line: clickBizLine ?? '-999'
                }
            }
        });
        _LXReport?.mvReport(LX_CONFIG.COMPARE_TAG_MV_BID, {
            valLab: {
                _moduleId: _moduleId ?? '-999',
                poi_id: poiId,
                item_index: itemIndex,
                is_privilege: privilegeTag,
                is_ddt_label: Boolean(angleImg?.needTag),
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999',
                    click_biz_line: clickBizLine ?? '-999'
                }
            }
        });
    };
    const hasSaleCount = originalPrice && sellPrice && Number(originalPrice) > Number(sellPrice);
    const linkComparisonComponent = () => {
        const poiId = extModel.poiIdStr || extModel.poiId;
        _LXReport?.mcReport(LX_CONFIG.COMPARE_TAG_MC_BID, {
            valLab: {
                _moduleId: _moduleId ?? '-999',
                poi_id: poiId,
                item_index: itemIndex,
                is_privilege: privilegeTag,
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999',
                    click_biz_line: clickBizLine ?? '-999'
                }
            }
        });
        ctx._communication?.emit('callPriceComparisonComponent', {
            poiInfoList: [{
                    poiId: poiId || extModel.poiIdStr || extModel.poiId,
                    latitude: lat,
                    longitude: lng
                }]
        });
    };
    return <Sensor once onAppear={() => {
        onCardShow();
    }}>
      <View className={styles[`cardContainer-${ShowSize[showType]}`]} style={{
        ...props.style,
        ...(isWeb ? {
            boxShadow: '0rpx 3rpx 9rpx 0rpx rgba(0, 0, 0, 0.12)'
        } : showType === SHOW_TYPE_ENUM.TWO_LIST ? {
            width: adaptScreenWidth() ?? '342rpx'
        } : {})
    }} onClick={() => {
        onCardClick();
    }}>
        
        <View className={styles[`topArea-${ShowSize[showType]}`]} onClick={isOpenComparePriceTag ? linkComparisonComponent : onCardClick}>
          <Image x-if={headImage?.value} style={ImageSize[ShowSize[showType]]} source={{
        uri: headImage.value ? headImage.value.replace('http:', 'https:').replace('/w.h/', '/') + '@684w' : ''
    }}></Image>
          <LinearGradient x-if={positionInfo && distanceInfoSwitch} className={styles.bookInfoContainer} colors={['#00000000', '#000000FF']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }}>
            <Image source={{
        uri: "https://p0.meituan.net/ingee/dee934b5bbd3366f424f011758894a48308.png"
    }} style={{
        width: "18rpx",
        height: "20rpx"
    }}></Image>
            <Text className={styles.bookInfo} numberOfLines={1}>{positionInfo}</Text>
          </LinearGradient>

          
          <CornerMark angleImg={angleImg} posTagList={posTagList} headIcon={headIcon} headIconImg={headIconImg} headIconText={headIconText} showCornerMark={showCornerMark} headIconTextColor={headIconTextColor} headIconBackgroundColor={headIconBackgroundColor} headIconBorderColor={headIconBorderColor}/>

          
          <View 
    // x-if={headIcon && headIconText && !headIconImg}
    x-if={isOpenComparePriceTag} style={{
        backgroundColor: headIconBackgroundColor
    }} className={styles.headIcon}>
            <Image className={styles.headIconImg} source={{
        uri: "https://p0.meituan.net/ingee/117b4ccdb1783336e3039cf5dacb27d32157.png"
    }}></Image>
          </View>
        </View>
        
        <View className={styles.bottomArea}>
          <View>
            <Text numberOfLines={2} style={{
        textOverflow: 'ellipsis'
    }} className={styles.poiName}>
              {title}
            </Text>
            <View className={styles.scoreRatingUserReviewContainer}>
              <Text x-if={userReview} numberOfLines={1} className={styles.userReview}>
                {userReview}
              </Text>
            </View>
            <View className={styles.smallTagContainer}>
              <View x-if={discountInfo} className={styles.discountContainer}>
                <Text className={styles.discountContent}>{discountInfo}</Text>
              </View>
              <View x-if={salesCount && salesInfoSwitch} className={styles.salesCountContainer}>
                <Text className={styles.salesCountContent}>{salesCount}</Text>
              </View>
            </View>
          </View>

          <View className={styles.priceArea}>
            
            <View className={styles.priceWrap}>
              <Text>
                <Text className={styles.prev}>￥</Text>
                <Text className={styles.price} style={{
        color: priceColor
    }}>
                  {sellPrice}
                </Text>
                <Text className={styles.behind}> 起</Text>
                <Text x-if={hasSaleCount} className={styles.originPrice}>{`￥${originalPrice}`}</Text>
              </Text>
            </View>
            <View className={styles.buyButtonWrap} style={{
        backgroundColor: status === GOODS_STATUS.CAN_SALE ? buyButtonBackgroundColor : '#CCCCCC'
    }}>
              <Text className={styles.buyButtonText} style={{
        color: status === GOODS_STATUS.CAN_SALE ? buyButtonTextColor : '#999999'
    }}>
                {status === GOODS_STATUS.CAN_SALE ? buyButtonText : '售罄'}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Sensor>;
};
export default memo(MyComponent);
